import Vue from 'vue' //vue.js 实例
import Router from 'vue-router' //vue 路由插件
const login = () => import('@/views/login/login') //登录页面
const mainroutecontent = () => import('@/views/mainroutecontent/mainroutecontent') //登录成功后页面主盒子
const personalcenter = () => import('@/views/personalcenter/personalcenter') //个人中心页面
const resourcedownloading = () => import('@/views/resourcedownloading/resourcedownloading') //资源下载列表
const resourcedetails = () => import('@/views/resourcedownloading/resourcedetails') //资源下载详情页
const sharingcenter = () => import('@/views/sharingcenter/sharingcenter') //产品分享列表
const sharingcenterdetails = () => import('@/views/sharingcenter/sharingcenterdetails') //产品分享详情页
const workshopDetails = () => import('@/views/personalcenter/workshopDetails') //老师资源审核详情页
const studentDetails = () => import('@/views/personalcenter/studentDetails') //学生资源审核详情页
const resourceDetails1 = () => import('@/views/personalcenter/resourceDetails1') //资源审核详情页
Vue.use(Router) // 依赖注入使用
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/mainroutecontent',
      name: 'mainroutecontent',
      component: mainroutecontent,
      children: [ //主盒子内的二级路由
        {
          path: '/personalcenter',
          name: 'personalcenter',
          component: personalcenter
        },
        {
          path: '/resourcedownloading',
          name: 'resourcedownloading',
          component: resourcedownloading
        },
        {
          path: '/resourcedetails',
          name: 'resourcedetails',
          component: resourcedetails
        },
        {
          path: '/sharingcenter',
          name: 'sharingcenter',
          component: sharingcenter
        },
        {
          path: '/sharingcenterdetails',
          name: 'sharingcenterdetails',
          component: sharingcenterdetails
        },
        {
          path: '/workshopDetails',
          name: 'workshopDetails',
          component: workshopDetails
        },
        {
          path: '/studentDetails',
          name: 'studentDetails',
          component: studentDetails
        },
        {
          path: '/resourceDetails1',
          name: 'resourceDetails1',
          component: resourceDetails1
        }
      ]
    }
  ]
}) //使用vue.js 路由构造函数
export default router //导出router 函数返回值
